import { defineStore } from 'pinia';

type GlobalState = {
  _loading: boolean;
  _progress: number | null;
};

export default defineStore('global', {
  state: (): GlobalState => ({
    _loading: true,
    _progress: null
  }),
  // Getters
  getters: {
    loading: (s): boolean => s._loading,
    progress: (s): number | null => {
      s._loading = true;
      return s._progress;
    }
  },
  // Actions
  actions: {
    /** Show loading Overlay */
    setLoading(display: boolean, delay: number = 500) {
      resetTimer();
      const self = this;

      if (delay > 0) setTimer(doSetLoading, delay);
      else doSetLoading();

      function doSetLoading() {
        self._loading = display;
        if (!display) {
          // Reset Progress value
          self._progress = null;
        }
      }
    },
    /** Update progress value */
    setProgress(progress: number | null = null) {
      // update progress value
      this._progress = progress;
      // display loading overlay
      this._loading = true;
    },
  },

  persist: {
    key: 'global',
    storage: window.localStorage,
  },
});

let _delayHandle: number | null = null;

function setTimer(handler: TimerHandler, delay: number) {
  _delayHandle = setInterval(handler, delay);
}

function resetTimer() {
  if (_delayHandle) {
    clearTimeout(_delayHandle);
    _delayHandle = null;
  }
}
